module.exports = __webpack_public_path__ + "static/media/16UNODC39.50113c9a.jpg";